import request from '@/utils/request';

// 查询全部分类
export function getPortalHelpClassifys() {
  return request({
    url: `/whitelist/front/portalHelpClassifys/allList`,
    method: 'get'
  });
}
// 首页默认分页查询
export function getQueryList(data) {
  return request({
    url: `/whitelist/front/portalHelpContents/queryList`,
    method: 'get',
    params: data
  });
}
// 指定类型分页查询
export function getPageList(data) {
  return request({
    url: `/whitelist/front/portalHelpContents/pageList`,
    method: 'get',
    params: data
  });
}
// 获取详细信息
export function getPageDetail(id) {
  return request({
    url: `/whitelist/front/portalHelpContents/${id}`,
    method: 'get'
  });
}
